import React from 'react';
import PropTypes from 'prop-types';

const LevelMarker = (props) => (
    <div className={`badge-level level-${props.level} level-${props.small ? 'sm' : 'md'} ${props.className || ''}`}>
        <span>{props.level}</span>
    </div>
);

LevelMarker.propTypes = {
    className: PropTypes.string,
    level: PropTypes.number.isRequired,
    small: PropTypes.bool
};

export default LevelMarker;
